var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 34.375L96 82.375C96 88.9925 90.6175 94.375 84 94.375L68 94.375L68 88.375L84 88.375C87.3075 88.375 90 85.6825 90 82.375L90 34.375C90 31.0675 87.3075 28.375 84 28.375L68 28.375L68 22.375L84 22.375C90.6175 22.375 96 27.7575 96 34.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55.375L24 61.375L81 61.375L81 55.375L24 55.375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2725 58.3751C83.2725 61.3626 82.11 64.1701 79.9975 66.2826L58.7825 87.4976L54.54 83.2551L75.755 62.0401C76.735 61.0601 77.2725 59.7601 77.2725 58.3751C77.2725 56.9901 76.7325 55.6901 75.755 54.7101L54.54 33.4951L58.7825 29.2526L79.9975 50.4676C82.11 52.5801 83.2725 55.3876 83.2725 58.3751Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.554369c9.svg";
export { ForwardRef as ReactComponent };